import { useEffect, useState } from 'react';

type Props = {
    children: React.ReactNode;
    delay?: number;
};

export default function ShowDelayed({ children, delay = 150 }: Props) {
    const [show, setShow] = useState(false);
    useEffect(() => {
        const timeoutId = window.setTimeout(() => {
            setShow(true);
        }, delay);
        return () => window.clearTimeout(timeoutId);
    }, [delay]);

    if (!show) {
        return null;
    }

    return <>{children}</>;
}
